
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMessagingTemplateDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    functionKey: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    variantKey: new FormControl<string | undefined>('', [Validators.maxLength(50)]),
    mailSubject: new FormControl<string | undefined>(undefined, [Validators.maxLength(150)]),
    message: new FormControl<string | undefined>(undefined),
})
;
}
      